import { subWeeks, subMonths, subYears, format } from 'date-fns';

export const MIN_DATE_OBJECT = new Date(2018, 0);
export const MAX_DATE_OBJECT = new Date(new Date().setHours(23, 59, 59, 999)); // max date is set to today's date with last hour, last minute, last second and last millisecond (this is done so that any new Date() object compares less than MAX_DATE_OBJECT)
export const MAX_DATE = format(MAX_DATE_OBJECT, 'dd/MM/yyyy');
export const MIN_DATE = format(MIN_DATE_OBJECT, 'dd/MM/yyyy');
export const ONE_THOUSAND_MILLI_SEC = 1000;
export const ONE_MIN_IN_MILLI_SEC: number = 60000;
export const THREE_DAYS = 262800000;
export const ONE_DAY_MILLI_SEC = 86340000; // 23 hours 59 minutes in millisecond
export const FIFTEEN_DAY_MILLI_SEC = 1296000000;
export const CURRENT_YEAR = new Date().getFullYear();

export const QUICK_FILTERS = {
	PAST_WEEK: 'Past Week',
	PAST_MONTH: 'Past Month',
	PAST_THREE_MONTHS: 'Past Three Months',
	PAST_SIX_MONTHS: 'Past Six Months',
	PAST_YEAR: 'Past Year',
	PAST_TWO_YEAR: 'Past Two Year',
	LIFE_TIME: 'Life Time'
};

export const QUICK_SELECT_OPTIONS = [
	{
		id: QUICK_FILTERS.PAST_WEEK,
		beginDate: subWeeks(MAX_DATE_OBJECT, 1)
	},
	{
		id: QUICK_FILTERS.PAST_MONTH,
		beginDate: subMonths(MAX_DATE_OBJECT, 1)
	},
	{
		id: QUICK_FILTERS.PAST_THREE_MONTHS,
		beginDate: subMonths(MAX_DATE_OBJECT, 3)
	},
	{
		id: QUICK_FILTERS.PAST_SIX_MONTHS,
		beginDate: subMonths(MAX_DATE_OBJECT, 6)
	},
	{
		id: QUICK_FILTERS.PAST_YEAR,
		beginDate: subYears(MAX_DATE_OBJECT, 1)
	},
	{
		id: QUICK_FILTERS.PAST_TWO_YEAR,
		beginDate: subYears(MAX_DATE_OBJECT, 2)
	},
	{
		id: QUICK_FILTERS.LIFE_TIME,
		beginDate: MIN_DATE_OBJECT
	}
];
